import React from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TopNav from '../components/TopNav';
import SideMenuTemplate from './templates/SideMenuTemplate';
import { Routes as AppRoutes } from '../utils/constants/routes';
import { Icons } from '../utils/constants/icons';

const drawerLinks = [
  { icon: Icons.ROSTER, label: 'Roster', path: AppRoutes.PEOPLE },
  { icon: Icons.TEAM, label: 'Teams', path: AppRoutes.TEAMS },
  { icon: Icons.ROLE, label: 'Roles', path: AppRoutes.ROLES },
  { icon: Icons.PERSON_LOCATION, label: 'Locations', path: AppRoutes.LOCATIONS },
];

const Wrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
});

const ContentWrapper = styled(Box)({
  flexGrow: 1,
  paddingTop: 64,
});

export const PeopleLayout = () => (
  <Wrapper>
    <TopNav />
    <ContentWrapper>
      <SideMenuTemplate title="People" links={drawerLinks} content={<Outlet />} />
    </ContentWrapper>
  </Wrapper>
);
